import { Radio, RadioGroup } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function CtrFlag({ value, onChange, name }) {
  const { t } = useTranslation()

  return (
    <RadioGroup orientation="horizontal">
      <Radio
        name={`radio-true-${name}`}
        checked={value === true}
        label={t('yes', 'Yes')}
        value="Yes"
        onChange={(e) => onChange(e.target.value)}
      />
      <Radio
        name={`radio-false-${name}`}
        checked={value === false}
        label={t('no', 'No')}
        value="No"
        onChange={(e) => onChange(e.target.value)}
      />
    </RadioGroup>
  )
}
